import {
  CONTENT_REVIEW_FETCH_SUCCESS,
  CONTENT_REVIEW_FETCH_FAIL,
  CONTENT_REVIEW_FETCH_BY_ID_SUCCESS,
  CONTENT_REVIEW_FETCH_BY_ID_FAIL,
  CONTENT_REVIEW_SET_DRAFT
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  contentReview: {},
  contentReviewDraft: {},
  contentReviewStore: {},
  contentReviews: [],
  isContentReviewFailed: false,
  isContentReviewLoaded: false,
  isFailed: false,
  isLoaded: false,
  page: null,
  totalPages: null
};

const contentReviewReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case CONTENT_REVIEW_SET_DRAFT: {
      logger.debug(`${CONTENT_REVIEW_SET_DRAFT}: ${JSON.stringify(data)}`);

      return {
        ...state,
        contentReviewDraft: data || {}
      };
    }

    case CONTENT_REVIEW_FETCH_SUCCESS: {
      logger.debug(`${CONTENT_REVIEW_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { reviews, totalPages, page } = data;

      return {
        ...state,
        contentReviews: reviews,
        isFailed: false,
        isLoaded: true,
        page,
        totalPages
      };
    }

    case CONTENT_REVIEW_FETCH_FAIL: {
      logger.debug(`${CONTENT_REVIEW_FETCH_FAIL}`);

      return { ...state, isFaled: true, isLoaded: true };
    }

    case CONTENT_REVIEW_FETCH_BY_ID_SUCCESS: {
      logger.debug(`${CONTENT_REVIEW_FETCH_BY_ID_SUCCESS}: ${JSON.stringify(data)}`);

      const { review } = data;
      const { _id } = review;

      const contentReviewStore = {
        ...state.contentReviewStore,
        [_id]: review
      };

      return {
        ...state,
        contentReview: review,
        contentReviewStore: { ...contentReviewStore },
        isContentFailed: false,
        isContentLoaded: true
      };
    }

    case CONTENT_REVIEW_FETCH_BY_ID_FAIL: {
      logger.debug(`${CONTENT_REVIEW_FETCH_BY_ID_FAIL}`);

      return { ...state, isContentFailed: true, isContentLoaded: true };
    }

    default:
      return state;
  }
};

export default contentReviewReducer;
